import { FC, useEffect } from "react";

interface MemberItem {
  employeeName?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  date?: string;

  total_working_hours?: number;
  allocated_working_hours?: number;
  utilization_percentage?: number;
  is_available?: boolean;

  [key: string]: any;
}

interface MemberListPopupProps {
  open: boolean;
  title: string;
  members: MemberItem[];
  onClose: () => void;
  onViewItem?: (item: MemberItem) => void;
  columns?: {
    key: string;
    label: string;
  }[];
}
function XIcon() {
  return (
    <svg className="w-5 h-5 relative top-[2.5px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

const MemberListPopup: FC<MemberListPopupProps> = ({
  open,
  title,
  members,
  onClose,
  onViewItem,
  columns = [
    { key: "employeeName", label: "Employee" },
    { key: "date", label: "Date" },
  ],
}) => {

        useEffect(() => {
          if (open) {
              document.body.classList.add("coverflow_hidden_scoll_bdy");
  
              return () => {
                  document.body.classList.remove("coverflow_hidden_scoll_bdy");
              };
          }
      }, [open]);
      
  if (!open) return null;



  return (
    <div className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center p-4">
      <div className=" overflow-hidden bg-white rounded-md shadow-2xl w-full max-w-[991px]">
        {/* Sticky Header */}
        <div className="sticky top-0 bg-white z-20 border-b px-3 pt-4 flex justify-between items-center">
          <h2 className=" mb-0 my-0 font-bold text-xl-dv text-black dark:text-white">
            {title} ({members.length})
          </h2>

          <button
            onClick={onClose}
            className="text-xl font-semibold hover:text-red-500 cta-red relative left-[-6px]"
          >
            <XIcon />
          </button>
        </div>

        {members.length === 0 ? (
          <div className="p-6 text-center text-gray-500">No records found.</div>
        ) : (
          <div className=" viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main ">
            <div className=" bg-white dark:dark:bg-slate-700  px-3 py-4  flex flex-col items-start justify-start gap-[24px] max-h-[400px] overflow-auto client-report-dtnamic-tbl ">
              {/* Sticky Table Header */}
              <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv ">
                <thead className="bg-surface-bg-secondary dark:bg-slate-600 bggraydark-dv">
                  <tr>
                    {columns.map((column) => (
                      <th
                        key={column.key}
                        className="text-left px-6 py-3 font-semibold"
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {members.map((member, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50">
                      {columns.map((column) => {
                        if (column.key === "_view") {
                          return (
                            <td key={column.key} className="px-6 py-3">
                              <button
                                className="emplink-item-dv viewlink-item-dv text-sm font-semibold"
                                onClick={() => onViewItem?.(member)}
                              >
                                View
                              </button>
                            </td>
                          );
                        }

                        let value: any = member[column.key];

                        switch (column.key) {
                          case "employeeName":
                            value =
                              member.employeeName ??
                              `${member.first_name ?? ""} ${member.last_name ?? ""}`.trim();
                            break;

                          case "is_available":
                            value = member.is_available ? "Yes" : "No";
                            break;

                          case "utilization_percentage":
                            value =
                              member.utilization_percentage !== undefined
                                ? `${member.utilization_percentage}%`
                                : "-";
                            break;

                          case "allocated_working_hours":
                            value =
                              member.allocated_working_hours !== undefined
                                ? `${member.allocated_working_hours.toFixed(2)} hrs`
                                : "-";
                            break;

                          case "total_working_hours":
                            value =
                              member.total_working_hours !== undefined
                                ? `${member.total_working_hours} hrs`
                                : "-";
                            break;

                          case "available_hours":
                            value =
                              (member.total_working_hours ?? 0) -
                              (member.allocated_working_hours ?? 0);
                            value = `${value.toFixed(2)} hrs`;
                            break;

                          default:
                            value = member[column.key] ?? "-";
                        }

                        return (
                          <td key={column.key} className="px-6 py-3">
                            <span className="text-sm px-[8px] dark:text-white"> {value}</span>
                          </td>
                          
                        );
                      })}
                    </tr>
                  ))}
                </tbody>

              </table>


            </div>
          </div>

        )}
      </div>
    </div>
  );
};

export default MemberListPopup;
